import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deleteAccountUser } from 'redux/actions/account';
import PropTypes from 'prop-types';
import PageTitle from 'components/PageTitle';
import Loader from 'components/Loader';
import Button from 'widgets/Button';
import { CrossStorageClient } from 'cross-storage';
import CheckBox from 'components/CheckBox';
import config from 'config';
import colors from 'assets/styles/jsVariables/colors';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import {
  clickDataPolicyDeleteAccount,
  clickConfirmDeleteAccount,
  clickMenuDataPolicy
} from 'libs/cleverTap';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import DeleteProcessingModal from 'views/DataPolicy/DeleteProcessingModal';
import './DataPolicy.scss';

const styles = {
  confirmButtonStyle: {
    '&:hover': {
      background: `${colors.darkerCyan} !important`,
      boxShadow: 'rgba(176, 176, 176, 0.5) 0px 2px 5px 1px'
    },
    boxShadow: 'none',
    height: '45px',
    width: '200px',
  },
  confirmButtonLabel: {
    fontFamily: 'museosansrounded_100',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '16px'
  }
};

const TOTAL_CHECKBOXES = 3;
const { CONNECT } = config;

class DataPolicy extends Component {
  constructor(props) {
    super(props);

    const { auth: { info: { subscriptions } } } = this.props;

    this.state = {
      open: false,
      hasConfirmed: true,
      hasActiveSubscription: subscriptions ? !!subscriptions.length : false,
      hasDeleted: false
    };
  }

  componentDidMount() {
    clickMenuDataPolicy();
  };

  componentDidUpdate(prevProps) {
    if (this.props.auth.info.subscriptions !== prevProps.auth.info.subscriptions) {
      const hasActiveSubscription = this.props.auth.info.subscriptions.length > 0;
      this.setState({ hasActiveSubscription });
    }
  };

  handleOpen = () => {
    this.setState({ open: true });
    clickDataPolicyDeleteAccount();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDelete = () => {
    this.handleClose();
    this.setState({ hasDeleted: true });
    this.props.deleteAccountUser();
    this.handleRemoteLogout();
    clickConfirmDeleteAccount();
  }

  handleRemoteLogout = () => {
    const storage = new CrossStorageClient(CONNECT.URL);
    storage.onConnect()
      .then(() => {
        storage.set('hasDeleted', true);
      });
  }

  handleCheckBox = () => {
    const checkedBoxes = document.querySelectorAll('input[name=chkBox]:checked');
    if (checkedBoxes.length === TOTAL_CHECKBOXES && this.state.hasActiveSubscription === false) {
      this.setState({ hasConfirmed: false });
    } else {
      this.setState({ hasConfirmed: true });
    }
  }

  render() {
    const { open, hasConfirmed, hasDeleted } = this.state;
    const { isFetching, auth: { isFetchingSubscriptions } } = this.props;

    const labelList = [
      { id: 1, label: <FormattedMessage id="views.dataPolicy.deleteAccount.checklist.1" /> },
      { id: 2, label: <FormattedMessage id="views.dataPolicy.deleteAccount.checklist.2" /> },
      { id: 3, label: <FormattedMessage id="views.dataPolicy.deleteAccount.checklist.3" /> },
    ];
    if (isFetching || isFetchingSubscriptions) {
      return <Loader />;
    }
    return (
      <div className="Data-Policy">
        <PageTitle
          title={<FormattedMessage id="views.dataPolicy.pageTitle" />}
          upperCase={false}
          labelStyle={{
            fontSize: '22px',
            color: colors.averageGrey,
            fontWeight: 500,
            letterSpacing: '0.25px',
            }}
          innerDivStyle={{ marginTop: '41px' }}
          dividerStyle={{ marginTop: '9px', marginLeft: '-3px', marginBottom: '12px' }}
        />
        <div className="Privacy__Title">
          <FormattedMessage id="views.dataPolicy.privacyTitle" />
        </div>
        <div className="Privacy__Description">
          <FormattedHTMLMessage
            id="views.dataPolicy.privacyDescription"
          />
          <div className="checkboxContainerBasicInfo">
            {labelList.map(element => (
              <CheckBox
                name="chkBox"
                key={element.id}
                label={<div style={{ paddingTop: '6px' }}>{element.label}</div>}
                style={{
                  strokeWidth: '1.1px',
                  stroke: colors.background,
                  padding: 0,
                }}
                containerStyle={{ paddingTop: '8px' }}
                onCheck={this.handleCheckBox}
              />
            ))}
          </div>
        </div>
        {this.state.hasActiveSubscription &&
          <div style={{ color: colors.red }}>
            <FormattedMessage id="views.dataPolicy.deleteAccount.validSubscriptionError" />
          </div>}
        <div className="Privacy__Action-Button">
          <Button
            id="DeleteMyAccountButton"
            variant="contained"
            color="primary"
            disabled={hasConfirmed}
            onClick={this.handleOpen}
            cssStyles={{
              root: styles.confirmButtonStyle,
              label: styles.confirmButtonLabel
            }}
            style={{
              background: hasConfirmed ? colors.disabledLighterCyan : colors.lighterCyan
            }}
          >
            <FormattedMessage id="views.dataPolicy.deleteAccount.button" />
          </Button>
        </div>
        <DeleteConfirmationModal
          isModalOpen={open}
          handleClose={this.handleClose}
          handleDelete={this.handleDelete}
        />
        { hasDeleted &&
          <DeleteProcessingModal
            isModalOpen
            handleClose={() => null}
          />
        }
      </div>
    );
  }
}

DataPolicy.propTypes = {
  deleteAccountUser: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  auth: PropTypes.any.isRequired,
};


const mapStateToProps = ({ account }) => ({
  isFetching: account.isFetching
});


export default connect(mapStateToProps, { deleteAccountUser })(DataPolicy);



// WEBPACK FOOTER //
// ./src/views/DataPolicy/DataPolicy.jsx